/**
 * Форменное окно — верхний слой стека модальных окон: поверх url-окна window.openModalUrl (слои последовательно
 * вызывают друг друга: openModalForm → openModalUrl → openModalWindow). Грузит GET-ом HTML с <form> и отправляет
 * его AJAX POST (FormData — включая @csrf и файлы). Футер собирается здесь, а не в config вызывающего:
 * «Отмена» (алиас modal-hide) и «Сохранить» (submitForm ниже). Нативная отправка формы запрещена — Enter в поле
 * не делает POST на текущую страницу. Дополнительные опции сверх окна:
 *   beforeFormSave(config, ajaxSettings) — вызывается перед отправкой; может изменить ajaxSettings на месте; false отменяет отправку.
 *   afterFormSave(config, data)          — вызывается после успешного сохранения (к этому моменту окно уже закрыто).
 */

/**
 * Открывает форменное окно: url-окно + свой футер и логика отправки формы.
 * element — элемент-триггер (сырой DOM-узел из jQuery-обработчика либо объект события);
 * config  — опции окна (+ хуки beforeFormSave/afterFormSave, см. шапку файла).
 */
window.openModalForm = function (element, config) {
    // Если прилетел event, выдергиваем из него нативный элемент кнопки (jQuery 3.x: e.currentTarget — совпавший триггер)
    element = (element && element.currentTarget) ? element.currentTarget : element;

    /**
     * onClick кнопки «Сохранить». Вызывается с аргументами (button, config): button — нажатая кнопка (jQuery), здесь не используется;
     * форма берётся из .modal-body окна. Отправляет её AJAX POST: при успехе закрывает окно, применяет data.reload / data.redirect,
     * показывает toast, если пришёл data.message, и вызывает afterFormSave(config, data); при 422 — выводит ошибки полей под полями
     * (.error-field-text.error-<name> + is-invalid на инпуте), при прочих ошибках — системный error-toast.
     * На время запроса submitBtn заблокирован (защита от двойного клика).
     */
    function submitForm(element, config) {
        let modal = config.modal;
        let form = modal.find(".modal-body form");
        if (!form.length) {
            console.warn("[form-modal] В ответе нет <form>: " + config.url);
            return;
        }

        let submitBtn = modal.find(".form-modal__submit"); // кнопка отправки

        // Контент TinyMCE-редакторов формы — в их textarea до сбора FormData (см. tinymce.js).
        window.syncTinymceEditorsIn(form[0]);

        let ajaxSettings = {
            url: config.url,
            type: "POST",
            data: new FormData(form[0]), // данные формы, включая @csrf и файлы
            processData: false,
            contentType: false,          // multipart/form-data — работает с загрузкой файлов
            dataType: "json",
            success: function (data) {
                modal.modal("hide");

                // Редиректы и перезагрузка
                if (data.reload === true) {
                    location.reload();
                }
                if (data.redirect !== undefined) {
                    window.location.href = data.redirect;
                }

                // Всплывающее уведомление
                if (data.message) {
                    window.showToast(data.message, data.status || 'success');
                }

                // Callback после успешного сохранения (окно уже закрыто)
                if (typeof config.afterFormSave === 'function') {
                    config.afterFormSave(config, data);
                }
            },

            error: function (data) {
                if (data.status === 422) {
                    // Ошибки валидации Laravel: текст под полем (.error-field-text.error-<name>) + is-invalid на инпуте.
                    let errors = data.responseJSON.errors || data.responseJSON;
                    for (let key in errors) {
                        let errorMessage = Array.isArray(errors[key]) ? errors[key][0] : errors[key];
                        modal.find(".error-field-text.error-" + key).text(errorMessage);
                        modal.find("*[name=" + key + "]").addClass("is-invalid");
                    }
                } else {
                    window.showToast('Системная ошибка. Попробуйте позже.', 'error');
                }
                submitBtn.prop("disabled", false);
            }
        };

        // Хук перед отправкой: может изменить ajaxSettings на месте; false — отмена отправки.
        if (typeof config.beforeFormSave === 'function') {
            let prepared = config.beforeFormSave(config, ajaxSettings);
            if (prepared === false) {
                return;
            }
        }

        submitBtn.prop("disabled", true); // защита от двойного клика во время запроса
        jQuery.ajax(ajaxSettings).always(function () {
            submitBtn.prop("disabled", false);
        });
    }

    // Хук вызывающего на вставку контента — не затираем, а догоняем после своего (к этому моменту форма уже в DOM).
    let userOnBeforeContentInsert = config && typeof config.onBeforeContentInsert === "function" ? config.onBeforeContentInsert : null;

    openModalUrl(element, Object.assign({}, { size: "lg" }, config || {}, {
        buttons: [
            {
                label: "Отмена",
                classes: "btn-secondary",
                onClick: "modal-hide"
            },
            {
                label: "Сохранить",
                classes: "btn-primary form-modal__submit",
                onClick: submitForm
            }
        ],
        // До вставки контента: проверяем, что в ответе есть <form>, и запрещаем нативную отправку формы (Enter в поле
        // улетел бы POST-ом на текущую страницу) — отправка только кнопкой. Делегирование на элемент модалки: форма
        // вставляется в DOM сразу после этого хука.
        onBeforeContentInsert: function (cfg, html) {
            if (!/<form[\s>]/.test(html)) {
                console.warn("[form-modal] В ответе нет <form>: " + cfg.url);
            }
            jQuery(cfg.modal).on("submit", "form", function (e) {
                e.preventDefault();
            });

            if (userOnBeforeContentInsert !== null) {
                userOnBeforeContentInsert(cfg, html);
            }
        }
    }));
};
